var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from "@core/views";
import Ajax from "@core/ajax";
import Toast from "@core/components/Toast";
var DimensioningView = /** @class */ (function (_super) {
    __extends(DimensioningView, _super);
    function DimensioningView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowInfoOnClick = function (el) {
            // construct url for info view
            var rowPk = el.getAttribute('data-row-pk');
            var jobType = el.getAttribute('data-job-type');
            var jobPk = el.getAttribute('data-job-pk');
            var url = "".concat(location.origin, "/dimensioning/").concat(jobType, "/").concat(jobPk, "/row/").concat(rowPk, "/info/");
            // get modal and form
            Ajax.get(url).then(function (html) {
                _this.modalMoreInfoEl.innerHTML = html;
                // prevent background from scrolling
                document.querySelector('html').classList.add('is-clipped');
                // add event listeners for modal close action
                document.querySelectorAll('.close').forEach(function (element) {
                    element.addEventListener('click', function (event) {
                        // allow page scroll when modal is removed from dom
                        document.querySelector('html').classList.remove('is-clipped');
                        // remove modal setting modal wrapper content empty
                        _this.modalMoreInfoEl.innerHTML = '';
                    });
                });
            }, function (error) {
                Toast.error(django.gettext('Error occurred requesting item information!'));
                console.error("Error occurred: ".concat(error.message));
            });
        };
        _this.rowOnClick = function (el) {
            // construct url for edit view
            var rowPk = el.getAttribute('data-row-pk');
            var jobType = el.getAttribute('data-job-type');
            var jobPk = el.getAttribute('data-job-pk');
            var url = "".concat(location.origin, "/dimensioning/").concat(jobType, "/").concat(jobPk, "/row/").concat(rowPk, "/edit/");
            // get modal and form
            Ajax.get(url).then(function (html) {
                _this.modalContainerEl.innerHTML = html;
                // prevent background from scrolling
                document.querySelector('html').classList.add('is-clipped');
                // add event listeners for modal close action
                document.querySelectorAll('.close').forEach(function (element) {
                    element.addEventListener('click', function (event) {
                        // allow page scroll when modal is removed from dom
                        document.querySelector('html').classList.remove('is-clipped');
                        // remove modal setting modal wrapper content empty
                        _this.modalContainerEl.innerHTML = '';
                    });
                });
                /*
                 * Form validation and submit. This is done via javascript because wrapping modal body with
                 * form element messed the content from scrolling. Moved form inside the modal body and handling
                 * work in here.
                 */
                document.querySelector('#row-edit-form-submit').addEventListener('click', function (event) {
                    var form = document.querySelector('#row-edit-form');
                    if (form.checkValidity())
                        form.submit();
                    else
                        form.reportValidity();
                });
            }, function (error) {
                Toast.error(django.gettext('Error occurred requesting item information!'));
                console.error("Error occurred: ".concat(error.message));
            });
        };
        _this.onDimensioningFormSubmit = function (event) {
            var submitButton = document.querySelector('#dimensioning-submit');
            submitButton.classList.add('is-loading');
            submitButton.disabled = true;
        };
        return _this;
    }
    DimensioningView.prototype.onMounted = function () {
        this.modalContainerEl = document.querySelector('#edit-modal');
        this.modalMoreInfoEl = document.querySelector('#info-modal');
        var form = document.querySelector('#calculate-dimensioning-form');
        if (form !== null) {
            form.addEventListener('submit', this.onDimensioningFormSubmit);
        }
    };
    return DimensioningView;
}(View));
export default DimensioningView;
